import type { VehicleData } from 'Pages/vehicles/helpers/vehicle.schema';

export const hasBodyDamage = (damageData: VehicleData['conditionAndDamage']) => {
	return [
		damageData.hasScratches,
		damageData.hasDents,
		damageData.hasPaintProblems,
		damageData.hasWindscreenProblems,
		damageData.hasMissingParts,
		damageData.hasWarningLights,
		damageData.hasBeenSmokedIn,
	].includes('Yes');
};
